import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private scriptLoader: ScriptLoaderService,private authService: AuthServiceService , private router:Router, private cartService: CartService ,private wishlist : WishlistService,) { }
  showLoading = false;
  userLogin = {
    username: '',
    password: ''
  };
  cartItems: any[] = [];
   wishlistCount: number = 0;
  cartCount: number = 0;
  rememberMe: boolean = false;
  errorMessage: string | null = null;
  showPassword: boolean = false;
   scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js'

  ];
  ngOnInit(): void {
    this.scriptLoader.loadScripts(this.scripts);
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
 goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  login(): void {
    this.showLoading = true;
    this.authService.login(this.userLogin).subscribe(
      (response) => {
        console.log('User logged in successfully:', response);

        if (this.rememberMe) {
          localStorage.setItem('access_token', response.access_token);
        } else {
          sessionStorage.setItem('access_token', response.access_token);
        }

        this.router.navigate(['/home']);
      },
      (error) => {
        console.error('Login failed:', error);
        this.errorMessage = 'Nom d’utilisateur ou mot de passe incorrect.';
        this.showLoading = false;
      }
    );
  }


  goToRegister() {
  this.router.navigate(['/register']);
  }
}
